export default {
  common: {
    errors: {
      title: "Помилка",
      warning: "Увага",
      note: "Примітка",
      searchSubscribers: "Пошук абонентів",
      pointAlreadyExists: "Показання з таким номером точки обліку вже існує",
      payDateDiff: "Дата оплати значно пізніше оплачуваного періоду",
      readingNotBeCalc:
        "Показання, введене для неіснуючої точки обліку, не буде враховуватися в розрахунках",
      conditionNotSet: "Умова не встановлено",
      usernameNotFoundInDatabase: "Логін не знайдений в базі",
      usernameOrPasswordNotFound: "Логін або пароль відсутні",
      accessDenied: "Доступ заборонено",
      invalidUsernameOrPassword: "Некоректний логін або пароль",
      accountExpired: "Термін дії облікового запису завершено",
      sessionExpired: "Час життя сесії минув",
      networkError: "Помилка при підключенні до сервера"
    },
    menu: {
      massinput: {
        name: "Масове введення",
        enteringPayments: {
          name: "Платежі",
          desc:
            "Введення комунальних платежів абонентів, отриманих від приймаючих організацій"
        },
        enteringSubsidies: {
          name: "Субсидії",
          desc:
            "Введення субсидій, компенсації інвалідам по зору і т. д., отриманих від відділу субсидій"
        }
      },
      subscribers: {
        name: "Абоненти",
        desc: "Пошук та перегляд інформації про абонентів"
      },
      searchchange: {
        name: "Пошук та редагування",
        errorpayments: {
          name: "Помилкові платежі",
          desc: "Перегляд та коригування помилкових платежів"
        }
      },
      paymentdocuments: {
        name: "Платіжні документи",
        bankPay: {
          name: "Банківські платежі",
          desc: "Робота з банківськими платежами"
        },
        packsReceipts: {
          name: "Пачки квитанцій/субсидій",
          desc: "Робота з заголовками пачок квитанцій/субсидій"
        },
        relationship: {
          name: "Зв'язок платежів і пачок",
          desc:
            "Встановлення відповідності між отриманими платіжними документами і пачками"
        },
        assignOperators: {
          name: "Призначення операторів",
          desc: "Призначення операторів для роботи з пачками"
        },
        controlPacks: {
          name: "Контроль розноски пачок",
          desc: "Контроль правильності розноски пачок"
        },
        controlInetPays: {
          name: "Контроль internet-платежів",
          desc: "Контроль за надходженням internet-платежів"
        }
      },
      reports: {
        name: "Звіти",
        desc: "Формування звітних форм"
      },
      acceptedshipment: {
        name: "Звіт про прийняте відвантаження",
        desc:
          'Звіт для порівняння прийнятого відвантаження від "Постачальника" та "Мережевої компанії"'
      },
      settings: {
        name: "Налаштування",
        desc: "Налаштування користувача"
      },
      user: {
        currentUser: "Користувач",
        currentConnection: "Підключення",
        about: "Про програму",
        settings: "Налаштування",
        signOut: "Вихід"
      }
    },
    about: {
      modal: {
        title: "Про програму",
        descritpionAbon: "Нарахування абонентської плати",
        descritpionComm: "за комунальні послуги",
        clientVersion: "Версія клієнта: {version}",
        serverVersion: "Версія сервера: {version}",
        apiVersion: "Версія сервера додатків: {version}"
      }
    },
    filter: {
      info: {
        periodWith: "Період з",
        periodTo: "по",
        sumMin: "Мін. сума",
        sumMax: "Макс. сума",
        statementSpaced: "Рознесені виписки",
        statementSet: "Виписки в наборі",
        organization: "Організація",
        payment: "Спосіб оплати",
        showSpaced: "Рознесені пачки",
        statusPack: "Статус пачки",
        operator: "Оператор"
      },
      modal: {
        title: "Фільтр на відображення даних"
      },
      form: {
        dateRange: {
          title: "Період дат",
          from: "с",
          start: "Початкова дата",
          end: "Кінцева дата",
          separator: "по"
        },
        sumRange: {
          title: "Сума",
          from: "від",
          to: "до"
        },
        statementStatus: {
          title: "Стан виписки",
          exploded: "Рознесена",
          unexploded: "Неразнесенная"
        },
        organization: {
          title: "Організація"
        },
        payment: {
          title: "Спосіб оплати"
        },
        showSpaced: {
          title: "Показати рознесені"
        },
        statusPack: {
          title: "Статус пачки"
        },
        operator: {
          title: "Оператор"
        }
      }
    },
    compliance: {
      info: {
        datesDifference: "Різниця між датами (в днях)",
        organizationsMatch: "Організації збігаються",
        paymentMethodsMatch: "Способи оплат збігаються",
        amountDifference: "Різниця в сумі"
      },
      modal: {
        title: "Параметри відповідності платежів і пачок"
      },
      form: {
        datesDifference: {
          title: "Дата з банку",
          days: "днів"
        },
        organizationsMatch: {
          title: "Організації збігаються"
        },
        paymentMethodsMatch: {
          title: "Способи оплат збігаються"
        },
        amountDifference: {
          title: "Різниця в сумі"
        }
      }
    },
    validations: {
      dateRange: {
        message: "Необхідно вибрати дату"
      },
      sumRange: {
        message: "Сума від не може бути більшою за суму до"
      },
      statementStatus: {
        message: "Необхідно вибрати тип виписки"
      },
      datebank: {
        message: "Необхідно вибрати дату",
        dateNow: "Дата з банку не може бути більше поточної дати",
        dateClose: "Дата з банку не може припадати на закритий місяць"
      },
      datepay: {
        message: "Необхідно вибрати дату",
        dateNow: "Дата оплати платежу не може бути більше поточної дати",
        dateCompare: "Дата оплати не може бути менше дати створення абонента"
      },
      quantity: {
        message: "Вкажіть кількість платежів",
        required: "Поле не може бути порожнім",
        status:
          "Кількість платежів у виписці і кількість введених платежів не збігаються"
      },
      countband: {
        required: "Поле не може бути порожнім"
      },
      summa: {
        message: "Вкажіть суму",
        required: "Поле сума не може бути порожнім",
        status: "Сума платежів у виписці і сума введених платежів не збігаються"
      },
      beneficiaryAccount: {
        message: "Необхідно вибрати р/рахунок отримувача"
      },
      paymentStatus: {
        message: "Необхідно вибрати тип платежу"
      },
      codefirme: {
        message: "Необхідно вибрати відправника"
      },
      payment: {
        message: "Необхідно вибрати спосіб оплати"
      },
      encoding: {
        message: "Необхідно вибрати кодування"
      },
      uploadFile: {
        message: "Необхідно вибрати як мінімум один файл",
        onlyOne: "Можна завантажити тільки один файл"
      },
      confirmeCodefirme: {
        message: "Необхідно вибрати організацію"
      },
      paynumber: {
        required: "Поле № документа не може бути порожнім"
      },
      rcount: {
        message: "Необхідно вибрати р/рахунок платника"
      },
      summaPack: {
        aboveZero: "Повинна бути більше нуля",
        notEqualZero: "Не може бути дорівнює нулю"
      },
      userPayment: {
        message: "Необхідно вибрати оператора"
      },
      codeImport: {
        message: "Необхідно вибрати тип вхідних даних"
      },
      files: {
        message: "Необхідно додати файл для імпорту"
      },
      reasonStorn: {
        message: "Необхідно вибрати причину"
      },
      statusCode: {
        message: "Необхідно вибрати статус пачки"
      },
      confirmDateBank: {
        message: "Необхідно вибрати дату"
      },
      codepay: {
        message: "Необхідно вибрати призначення платежу"
      },
      sumPay: {
        message: "Сума не може бути порожньою",
        sumGrtZero: "Сума платежу повинна бути більше нуля"
      },
      datePayPeriod: {
        message: "Необхідно вказати дату початку періоду",
        datePayEnd: "Необхідно вказати дату закінчення періоду",
        datePayCompare: "Початкова дата повинна бути менше кінцевої"
      },
      reasonReturnPack: {
        message: "Необхідно вибрати причину повернення пачки"
      },
      massInputQuantity: {
        message: "Поле не може бути порожнім",
        quantityGrtZero: "Кількість квитанцій має бути більше нуля",
        subscribersGrtZero: "Кількість абонентів має бути більше нуля "
      },
      massInputTotalSum: {
        message: "Поле не може бути порожнім",
        sumGrtZero: "Загальна сума повинна бути більше нуля"
      },
      sumBegin: {
        beginGtEnd: "Початкова сума не може бути більшою за кінцеву",
        endSumEmpty: "Необхідно вибрати кінцеву суму"
      },
      sumEnd: {
        endLtBegin: "Кінцева сума не може бути меншою за початкову",
        beginSumEmpty: "Необхідно обрати початкову суму"
      },
      dateBegin: {
        beginIsAfterEnd: "Початкова дата не може бути більшою за кінцеву",
        endDateEmpty: "Необхідно вибрати кінцеву дату"
      },
      dateEnd: {
        endIsBeforeBegin: "Кінцева дата не може бути меншою за початкову",
        beginDateEmpty: "Необхідно вибрати початкову дату"
      }
    },
    gridColumns: {
      nameaccount: "Р/рахунок",
      datebank: "Дата по банку",
      datebankPay: "Дата перерахування",
      quantityPay: "Кількість платежів",
      totalSumma: "Загальна сума",
      summa: "Сума",
      sumwithoutprof: "Сума без послуг",
      summtrans: "Сума перерахування",
      summpay: "Сума оплат",
      status: "Стан",
      astatus: "Ком. збір",
      datebeginfact: "Дата",
      dateDelete: "Дата видалення",
      username: "Оператор",
      namefirme: "Платник",
      namefirmeSender: "Відправник",
      namefirmeSenderPay: "Відправник платежу",
      okpo: "ОКПО",
      okpoPay: "ОКПО платника",
      datepay: "Дата оплати",
      paynumber: "№ платежу",
      mess: "Примітка",
      npack: "Чи пов'язаний з пачкою",
      npackStatus: "Статус платежу",
      npackSystem: "Системний номер пачки",
      kindname: "Спосіб оплати",
      countband: "Кількість бандеролей",
      countbands: "Бандеролей",
      quantity: "Кількість квитанцій",
      quantitys: "Квитанцій",
      sumprof: "За послуги",
      isimport: "Імпорт",
      packnumber: "Номер пачки",
      abcode: "Л/рахунок",
      abcodeLong: "Особовий рахунок",
      fio: "ПІБ",
      payname: "Призначення платежу",
      dateval: "Дата зняття показань",
      counter: "Показання",
      impFile: "Файл",
      processed: "Оброблено",
      transferid: "Код реєстру",
      statusname: "Статус",
      nband: "№",
      countpay: "Кількість",
      countpays: "Кількість оплат",
      abcodeNumber: "О/рахунок",
      nameplat: "Послуга",
      adress: "Адреса",
      intkey: "Код платежу",
      reasonname: "Причина повернення",
      clientId: "ID",
      regionName: "Район",
      streetName: "Вулиця",
      nHouse: "№ будинку",
      charHouse: "Буква",
      nFlat: "Квартира",
      charFlat: "Буква кв-ри",
      phone: "Телефон",
      dateCreate: "Відкрито",
      dateClose: "Закрито",
      arch: "Архів",
      postIndex: "Поштовий індекс",
      countRoom: "Номер ділянки",
      partyHouse: "Під'їзд",
      floor: "Поверх",
      topIndex: "№ точки обліку",
      service: "Послуга",
      zone: "Зона",
      reading: "Показання",
      status: "Враховуються",
      payment: "Платіж",
      error: "Помилка",
      npack: "Пачка",
      sumorig: "Сума у валюті оплати",
      currencyname: "Валюта оплати",
      bank: "Банк",
      validity: "Період дії",
      datebegin: "Дата початку",
      dateend: "Дата закінчення",
      makingEntry: "Внесення запису",
      house: "Будинок",
      charHouseLong: "Літера будинку",
      charFlatLong: "Літера квартири",
      closeReasonName: "Причина закриття о/рахунку",
      habitName: "Тип будівлі",
      propertyName: "Тип власності",
      npack: "№ пачки",
      lists: "Аркушів",
      subsidiesSocBenefits: "Субсидій/соц.доплат",
      appointmentDate: "Дата призначення",
      dateBeginAction: "Початок дії",
      dateEndAction: "Закінчення дії",
      dateReading: "Дата зняття показання",
      organization: "Організація"
    },
    types: {
      status: {
        posting: "рознесена",
        inSet: "в наборі"
      },
      astatus: {
        yes: "є",
        no: "ні"
      },
      npackStatus: {
        alien: "чужий",
        associatedPack: "пов'язаний з пачкою",
        expectedPack: "очікується пачка"
      },
      processed: {
        yes: "так",
        no: "ні"
      }
    },
    options: {
      payment: {
        zero: "має бути прив'язаний до відповідної пачки",
        one: "чужий"
      },
      searchTypes: {
        matches: "= збігається",
        contains: "* містить",
        startsOn: "> починається на",
        endsOn: "< закінчується на"
      },
      searchDateTypes: {
        equal: "дорівнює",
        between: "між"
      }
    },
    buttons: {
      filter: "Фільтр",
      compliance: "Відповідність",
      add: "Додати",
      edit: "Змінити",
      delete: "Сторнувати",
      deletePacks: "Видалені пачки",
      remove: "Видалити",
      removeAll: "Видалити всі",
      fix: "Виправити",
      distribute: "Рознести",
      import: "Імпорт",
      imports: "Імпортувати",
      report: "Звіт",
      importDots: {
        import: "Імпортувати...",
        payments: "платежі",
        subsidies: "субсидії",
        dbfFile: "DBF-файл",
        csvFile: "CSV-файл"
      },
      extraDots: {
        extra: "Додатково...",
        indefinite: "подивитися квитанції з невизначеними показаннями"
      },
      viewDots: {
        view: "Вид",
        optimal: "Оптимальний",
        full: "Повний"
      },
      alien: "Чужий",
      posting: "Рознести",
      submit: "Підтвердити",
      cancel: "Скасувати",
      refund: "Повернути",
      selectFile: "Вибрати файл",
      addFile: "Додати файл",
      deleteFile: "Видалити файл",
      upload: "Завантажити",
      close: "Закрити",
      link: "Зв'язати",
      linkAndPosting: "Зв'язати і Рознести",
      packForPayment: "Створити пачку по платежу",
      assign: "Призначити",
      unassign: "Звільнити",
      receipts: "Квитанції",
      moveToNextMonth: "Перенести на наступний місяць",
      cancelReceivedRegistry: "Скасувати отриманий результат",
      cancelSubscriberPayment: "Скасувати оплату абонента",
      confirmYes: "Так",
      confirmNo: "Ні",
      confirmOk: "OK",
      infoPay: "Інформація про платіж",
      errorPayments: "Помилкові платежі", // delete this ?
      searchSubscribers: "Пошук абонентів",
      searchPayments: "Пошук платежів",
      subscriberCard: "Картка абонента",
      search: "Знайти",
      clear: "Очистити",
      aboutClient: "Про клієнта",
      return: "Повернути",
      postpone: "Відкласти",
      distributeAll: "Рознести все",
      refreshList: "Оновити список",
      check: "Перевірити",
      save: "Зберегти"
    },
    components: {
      select: {
        placeholder: "Вибір"
      },
      datePicker: {
        placeholder: "Дата",
        today: "Сегодня",
        yesterday: "Вчора"
      }
    },
    reference: {
      statusName: {
        inSet: "в наборі",
        inPosting: "в разноске",
        spaced: "рознесена",
        notConnected: "не пов'язана",
        erroneous: "помилкова",
        canceled: "сторнирована"
      },
      paymentName: {
        preparationPayment: "підготовка до оплати",
        paymentMade: "оплата здійснена",
        paymentNotMade: "плата не здійснена",
        undefined: "не визначений"
      },
      deliveryName: {
        moneySent: "гроші відправлені",
        paymentNotDeterm: "платіж не визначений",
        mismatchAmounts: "невідповідність сум",
        undefined: "не визначений"
      }
    },
    checkVersion: {
      api: "Версія API повинна бути",
      server: "Версія сервера повинна бути",
      callTo: "або вище, зверніться до адміністратора для оновлення сервера",
      serverError: "Помилка з'єднання на сервері:",
      dataBase: "Версія бази даних",
      appServer: "не відповідає версії сервера додатків"
    },
    address: {
      street: "вул. ",
      house: " буд.",
      flat: " кв.",
      address: "адреса:",
      abcode: "о/р"
    },
    route: {
      leave:
        "Залишилися ще нерознесені пачки. Бажаєте залишити їх нерознесеними?"
    }
  }
};
